import axios from "axios";
import { toast } from "sonner";
const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

// Token lives in sessionStorage so it is cleared when the browser/tab is closed.
export const getToken = () => sessionStorage.getItem("token") || "";
export const setToken = (t) => { if (t) sessionStorage.setItem("token", t); else sessionStorage.removeItem("token"); };

let activeBiz = localStorage.getItem("business_id") || "";
export const setActiveBusiness = (id) => { activeBiz = id || ""; };

let activeFy = localStorage.getItem("fin_year") || "";
export const setActiveFinYear = (fy) => { activeFy = fy || ""; };

const client = axios.create({ baseURL: API });
client.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  if (activeBiz) cfg.headers["X-Business-Id"] = activeBiz;
  if (activeFy) cfg.headers["X-Fin-Year"] = activeFy;
  return cfg;
});
client.interceptors.response.use(
  (r) => r,
  (err) => {
    const s = err.response?.status;
    if (s === 401) setToken("");
    if (s === 403) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "You do not have permission for this action");
    }
    if (s === 402) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Access limit reached. Please contact the administrator.");
    }
    return Promise.reject(err);
  }
);

export const api = {
  get: (u, cfg) => client.get(u, cfg).then((r) => r.data),
  post: (u, b, cfg) => client.post(u, b, cfg).then((r) => r.data),
  put: (u, b) => client.put(u, b).then((r) => r.data),
  del: (u) => client.delete(u).then((r) => r.data),
};
export const fileUrl = (path) => `${API}${path}`;
export const downloadAuthed = async (path, filename) => {
  const headers = { Authorization: `Bearer ${getToken()}` };
  if (activeBiz) headers["X-Business-Id"] = activeBiz;
  if (activeFy) headers["X-Fin-Year"] = activeFy;
  const res = await fetch(`${API}${path}`, { headers });
  if (!res.ok) { toast.error("Download failed"); return; }
  const blob = await res.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  window.URL.revokeObjectURL(url);
};
export const uploadFile = async (path, file, fields = {}) => {
  const fd = new FormData();
  fd.append("file", file);
  Object.entries(fields).forEach(([k, v]) => fd.append(k, v));
  return client.post(path, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export default client;
